import { Component, input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TERMS_AND_CONDITIONS_CONTENT } from './constants';

@Component({
  selector: 'lib-terms-and-conditions',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './terms-and-conditions.component.html',
})
export class TermsAndConditionsComponent {
  constructor(private readonly _translate: TranslateService) {}

  content = input<string>();

  public get termsAndConditionsContent(): string {
    if (this.content()) {
      return this.content() + '';
    }
    const lang = this._translate.currentLang || this._translate.defaultLang;
    const content = TERMS_AND_CONDITIONS_CONTENT;

    if (lang === 'es') {
      return content.es;
    }

    // Default to English for 'en' or any other language
    return content.en;
  }
}
